import { render, staticRenderFns } from "./CreateUserDrawer.vue?vue&type=template&id=684d3045"
import script from "./CreateUserDrawer.vue?vue&type=script&lang=js"
export * from "./CreateUserDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports